<template>
  <div>
    <div class="clearfix english_contentbox" v-if="cetIndex !== -1">
      <!--课程科目为空的时候上部分S-->
      <div class="clearfix">
        <div class="fl english_classleftbox">
          <div class="clearfix english_classtitbox bbcolor">
            <h3 class="fl english_classtit">新概念</h3>
            <ul class="fl english_titlist">
              <li attr="146" v-show="cet['146'].list!= ''" :class="cetIndex === 0 ? 'yxempty_titliston' : ''" data-index=0 @click="cetChange(0)">初中</li>
              <li attr="986" v-show="cet['986'].list != ''" :class="cetIndex === 1 ? 'yxempty_titliston' : ''" data-index=1 @click="cetChange(1)">高中</li>
              <li attr="147" v-show="cet['147'].list != ''" :class="cetIndex === 2 ? 'yxempty_titliston' : ''" data-index=2 @click="cetChange(2)">大学</li>
              <li attr="148" v-show="cet['148'].list != ''" :class="cetIndex === 3 ? 'yxempty_titliston' : ''" data-index=3 @click="cetChange(3)">成人</li>
            </ul>
          </div>

          <div class="clearfix english_classggbox">
            <div class="fl english_classgg">
              <img src="http://file.xdf.cn/neworiental/images/english_newconcept.png" alt="">
            </div>
            <ul class="fl english_classlist" v-show="cetIndex === cetItem.index" v-for="(cetItem, key) in cet" :key=key>
              <a class="fl" v-for="(item, index) in cetItem.list" :key="index" :href="`http://souke.xdf.cn/Class/${$store.state.soukecityId}-${item.Id}.html`">
                <div class="english_classimg">
                  <img :src="getTeacher(item.TeacherList).NewLogoUrl">
                </div>
                <p class="english_classname">{{getTeacher(item.TeacherList).Name}}</p>
                <h4 class="guess_titilesmall">{{item.FullName}}</h4>
                <p class="clearfix mb10">
                  <span class="fl guess_adressicon"></span>
                  <span class="fl guess_adress">{{item.LearnPlace}}</span>
                </p>
                <p class="clearfix mb10">
                  <span class="fl guess_timeicon"></span>
                  <span class="fl guess_adress">{{getLearnTime(item.StartDate)}}</span>
                </p>
                <p class="guess_money mt0 fl"><span>￥</span>{{item.Price}}</p>
              </a>
            </ul>
            <ul class="fl english_classlist" v-show="cetIndex === 1">
              <a class="fl" v-for="(item, index) in cet.duoyuan" :key="index" :href="`http://souke.xdf.cn/Class/${$store.state.soukecityId}-${item.Id}.html`">
                <div class="english_classimg">
                  <img :src="getTeacher(item.TeacherList).NewLogoUrl">
                </div>
                <p class="english_classname">{{getTeacher(item.TeacherList).Name}}</p>
                <h4 class="guess_titilesmall">{{item.FullName}}</h4>
                <p class="clearfix mb10">
                  <span class="fl guess_adressicon"></span>
                  <span class="fl guess_adress">{{item.LearnPlace}}</span>
                </p>
                <p class="clearfix mb10">
                  <span class="fl guess_timeicon"></span>
                  <span class="fl guess_adress">{{getLearnTime(item.StartDate)}}</span>
                </p>
                <p class="guess_money mt0 fl"><span>￥</span>{{item.Price}}</p>
              </a>
            </ul>
          </div>

        </div>
        <zixun title="新概念百宝箱" typeids='912,913,1752,1753,1754,1755' cow="4"></zixun>
      </div>
      <!--课程科目为空的时候上部分E-->
    </div>

    <div class="clearfix english_contentbox" v-if="postgraduateIndex !== -1">
      <!--课程科目为空的时候上部分S-->
      <div class="clearfix">
        <div class="fl english_classleftbox">
          <div class="clearfix english_classtitbox bbcolor">
            <h3 class="fl english_classtit">口语提高</h3>
            <ul class="fl english_titlist">
              <li attr="406" v-show="postgraduate['406'].list != ''" :class="postgraduateIndex === 0 ? 'yxempty_titliston' : ''" data-index=0 @click="postgraduateChange(0)">倍学口语</li>
              <li attr="18" v-show="postgraduate['18'].list != ''" :class="postgraduateIndex === 1 ? 'yxempty_titliston' : ''" data-index=1 @click="postgraduateChange(1)">口语外教</li>
            </ul>
          </div>

          <div class="clearfix english_classggbox">
            <div class="fl english_classgg">
              <img src="http://file.xdf.cn/neworiental/images/english_speaking.png" alt="">
            </div>
            <ul class="fl english_classlist" v-show="postgraduateIndex === postgraduateItem.index" v-for="(postgraduateItem, key) in postgraduate" :key=key>
              <a class="fl" v-for="(item, index) in postgraduateItem.list" :key="index" :href="`http://souke.xdf.cn/Class/${$store.state.soukecityId}-${item.Id}.html`">
                <div class="english_classimg">
                  <img :src="getTeacher(item.TeacherList).NewLogoUrl">
                </div>
                <p class="english_classname">{{getTeacher(item.TeacherList).Name}}</p>
                <h4 class="guess_titilesmall">{{item.FullName}}</h4>
                <p class="clearfix mb10">
                  <span class="fl guess_adressicon"></span>
                  <span class="fl guess_adress">{{item.LearnPlace}}</span>
                </p>
                <p class="clearfix mb10">
                  <span class="fl guess_timeicon"></span>
                  <span class="fl guess_adress">{{getLearnTime(item.StartDate)}}</span>
                </p>
                <p class="guess_money mt0 fl"><span>￥</span>{{item.Price}}</p>
              </a>
            </ul>
          </div>
        </div>
        <zixun title="口语提高" typeids='2458,5912,903,8321' cow="4"></zixun>
      </div>
      <!--课程科目为空的时候上部分E-->
    </div>

    <div class="clearfix english_contentbox" v-if="abroadIndex !== -1">
      <!--课程科目为空的时候上部分S-->
      <div class="clearfix">
        <div class="fl english_classleftbox">
          <div class="clearfix english_classtitbox bbcolor">
            <h3 class="fl english_classtit">职场英语</h3>
            <ul class="fl english_titlist">
              <li attr="42" v-show="abroad['42'].list != ''" :class="abroadIndex === 0 ? 'yxempty_titliston' : ''" data-index=0 @click="abroadChange(0)">商务英语</li>
              <li attr="187" v-show="abroad['187'].list != ''" :class="abroadIndex === 1 ? 'yxempty_titliston' : ''" data-index=1 @click="abroadChange(1)">BEC</li>
              <li attr="168" v-show="abroad['168'].list != ''" :class="abroadIndex === 2 ? 'yxempty_titliston' : ''" data-index=2 @click="abroadChange(2)">TOEIC</li>
            </ul>
          </div>

          <div class="clearfix english_classggbox">
            <div class="fl english_classgg">
              <img src="http://file.xdf.cn/neworiental/images/english_workplace.png" alt="">
            </div>
            <ul class="fl english_classlist" v-show="abroadIndex === abroadItem.index" v-for="(abroadItem, key) in abroad" :key=key>
              <a class="fl" v-for="(item, index) in abroadItem.list" :key="index" :href="`http://souke.xdf.cn/Class/${$store.state.soukecityId}-${item.Id}.html`">
                <div class="english_classimg">
                  <img :src="getTeacher(item.TeacherList).NewLogoUrl">
                </div>
                <p class="english_classname">{{getTeacher(item.TeacherList).Name}}</p>
                <h4 class="guess_titilesmall">{{item.FullName}}</h4>
                <p class="clearfix mb10">
                  <span class="fl guess_adressicon"></span>
                  <span class="fl guess_adress">{{item.LearnPlace}}</span>
                </p>
                <p class="clearfix mb10">
                  <span class="fl guess_timeicon"></span>
                  <span class="fl guess_adress">{{getLearnTime(item.StartDate)}}</span>
                </p>
                <p class="guess_money mt0 fl"><span>￥</span>{{item.Price}}</p>
              </a>
            </ul>
          </div>
        </div>
        <zixun title="职场英语" typeids='1949,1947,1948' cow="4"></zixun>
      </div>
      <!--课程科目为空的时候上部分E-->
    </div>

  </div>
</template>

<script>
import Zixun from './Zixun'
import {getClassBySearch} from 'js/getSoukeData.js'
export default {
  name: 'englishMainfloor',
  data () {
    return {
      nodataCheck: 0,
      cet: {
        146: {index: 0, list: []},
        986: {index: 1, list: []},
        147: {index: 2, list: []},
        148: {index: 3, list: []}
      },
      postgraduate: {
        406: {index: 0, list: []},
        18: {index: 1, list: []}
      },
      abroad: {
        42: {index: 0, list: []},
        187: {index: 1, list: []},
        168: {index: 2, list: []}
      },
      cetIndex: -1,
      postgraduateIndex: -1,
      abroadIndex: -1,
      cetShow: false,
      postgraduateShow: false,
      abroadShow: false
    }
  },
  components: {
    Zixun
  },
  computed: {
    getLearnTime (time) {
      return function (time) {
        if (time) {
          return time.split('T')[0]
        }
      }
    },
    getTeacher (teacherArr) {
      return function (teacherArr) {
        if (teacherArr !== '') {
          return {NewLogoUrl: 'http://file.xdf.cn/neworiental/images/teacherImgOneToOne.png', Name: '待定'}
        } else {
          return {
            NewLogoUrl: `http://img.xdf.cn/TeacherIMG/${teacherArr.NewLogoUrl}`,
            Name: teacherArr.Name
          }
        }
      }
    },
    cityId () {
      return this.$store.state.soukecityId
    }
  },
  created () {
    this.getCetData()
  },
  methods: {
    cetChange (index) {
      this.cetIndex = index
    },
    postgraduateChange (index) {
      this.postgraduateIndex = index
    },
    abroadChange (index) {
      this.abroadIndex = index
    },
    getCetData () {
      let _this = this
      for (let key in this.cet) {
        getClassBySearch(this.$store.state.soukecityId, 3, 6, key).then(function (response) {
          if (response.ClassList.length === 3) {
            _this.cet[key].list = response.ClassList
            if (_this.cetIndex === -1) {
              _this.cetIndex = _this.cet[key].index
            }
          }
        }).catch(function () {
        })
      }

      for (let key in this.postgraduate) {
        getClassBySearch(this.$store.state.soukecityId, 3, key, 0).then(function (response) {
          if (response.ClassList.length === 3) {
            _this.postgraduate[key].list = response.ClassList
            if (_this.postgraduateIndex === -1) {
              _this.postgraduateIndex = _this.postgraduate[key].index
            }
          }
        }).catch(function () {
        })
      }

      for (let key in this.abroad) {
        getClassBySearch(this.$store.state.soukecityId, 3, key, 0).then(function (response) {
          if (response.ClassList.length === 3) {
            _this.abroad[key].list = response.ClassList
            if (_this.abroadIndex === -1) {
              _this.abroadIndex = _this.abroad[key].index
            }
          }
        }).catch(function () {
        })
      }
    }
  },
  watch: {
    cityId (newVal, oldVal) {
      this.getCetData()
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
.fl
  float: left
.fr
  float: right
.mb10
  margin-bottom: 7px
.clear:after
  content: ''
  display: block
  clear: both
.clearfix:after
  display: block
  content: ""
  clear: both
.english_contentbox
  width: 1200px
  margin: 50px auto
  .english_classleftbox
    width:934px
    .english_classtitbox
      width: 934px
      height: 36px
      line-height: 36px
      border-bottom: 1px solid #dee1e9
      .english_classtit
        width: 196px
        font-size: 22px
        color: #333
        margin-right: 10px
      .english_titlist
        li
          height: 36px
          line-height: 36px
          padding: 0 28px
          float: left
          border-left: 1px solid #fff
          border-right: 1px solid #fff
          font-size: 16px
          color: #333333
          cursor: pointer
        .english_titliston
          color: #31A893
          border-bottom: 1px solid #31A893
      .english_morebtn
        font-size: 14px
        color: #31a893
        background: url(http://file.xdf.cn/neworiental/images/english_indexbg.png?190315) no-repeat 7px -170.5px
        padding-right: 10px
    .bbcolor
      border-bottom: 2px solid #a5e1d6
    .english_classggbox
      margin-top: 16px
      .english_classgg
        width: 193px
        height: 327px
        img
          width:100%
          height:100%
      .english_classlist
        width: 740px
        a
          display: block
          width: 236px
          height: 327px
          background: #f7f9fb
          padding: 28px 16px
          box-sizing: border-box
          margin-left: 10px
          &:hover
            box-shadow: 1px 5px 10px 1px #e5e5e5
            background:#fff
            .guess_titilesmall
              color: $themeColor
          .english_classimg
            width: 114px
            height: 114px
            margin: 0 auto
            border-radius: 50%
            overflow: hidden
            img
              width: 100%
              height: 100%
          p
            .guess_adressicon
              display: inline-block
              width: 12px
              height: 14px
              background: url(http://images.xdf.cn/cms20150819/zuixinban/images/adress.png) no-repeat
              margin-top: -1px
              margin-right:5px
            .guess_adress
              width: 80%
              color: #9c9c9c
              font-size: 12px
              overflow: hidden
              white-space: nowrap
            .guess_timeicon
              display: inline-block
              width: 12px
              height: 12px
              background: url(http://images.xdf.cn/cms20150819/zuixinban/images/guess_time.png) no-repeat
              margin-right: 5px
              margin-top: -1px
          .english_classname
            width: 100%
            text-align: center
            font-size: 20px
            color: #333333
            margin-top: 15px
            margin-bottom: 31px
          .guess_titilesmall
            font-size: 14px
            color: #3f3f3f
            margin-bottom: 13px
            display: block
            width: 183px
            overflow: hidden
            white-space: nowrap
            text-overflow ellipsis
          .guess_money
            color: #ff7011
            font-size: 19px
            margin-top:10px
            span
              font-size: 14px
    .english_emptybox
      width: 100%
      font-size: 13px
      text-align: center
      margin-top: 57px
      .english_emptyimgword
        position: relative
        width: 100%
        height: 410px
        color: #2db6e7
        text-align: left
        .english_emptyimg
          width: 880px
          height: 267px
          margin-top: 38px
          img
            width: 100%
            height: 100%
        p
          width: 156px
          line-height: 18px
          position: absolute
        .english_emptyimgword1
          top: 281px
          left: 16px
        .english_emptyimgword2
          top: 278px
          left: 231px
        .english_emptyimgword3
          top: 246px
          left: 435px
          width: 181px
        .english_emptyimgword4
          top: 27px
          left: 776px
          width: 118px
        .english_emptyimgword5
          top: 257px
          left: 670px
          width: 167px
    .english_classtitbox
      width: 934px
      height: 36px
      line-height: 36px
      border-bottom: 1px solid #dee1e9
    .bbcolor
      border-bottom: 2px solid #a5e1d6
      .english_classtit
        width: 194px
        font-size: 22px
        color: #333
        margin-right: 10px
      .english_titlist
        li
          height: 36px
          line-height: 36px
          padding: 0 28px
          float: left
          border-left: 1px solid #fff
          border-right: 1px solid #fff
          font-size: 16px
          color: #333333
          cursor: pointer
        .yxempty_titliston
          border-left: 1px solid #a5e1d6
          border-right: 1px solid #a5e1d6
          border-top: 2px solid $themeColor
          background: #fff
          height: 38px
          line-height: 36px
          margin-top: -2px
          color: $themeColor
    .english_emptybox
      width: 100%
      font-size: 13px
      text-align: center
      .english_emptytit
        font-size: 26px
        color: #31a893
        margin-top: 75px
      .english_EnglishSystem
        margin: 0 auto
        margin-left: 28px
        margin-top: 20px
        div
          width: 284px
          height: 510px
          margin: 20px 3px
          position: relative
        .english_EnglishSystem1
          background: url(http://file.xdf.cn/neworiental/images/yxEmptybg.png?asd) no-repeat -251px -1255px
          h4
            font-size: 26px
            position: absolute
            top: 55px
            left: 100px
            color: #fff
          .english_systemlist
            position: absolute
            top: 130px
            left: 12px
            width: 230px
            height: 360px
            text-align: left
            li
              width: 100%
              margin-top: 10px
              h5
                font-size: 14px
                position: relative
                padding-left: 7px
              .color3-4
                color: #f5626b
              p
                line-height: 22px
                color: #666666
                margin-top: 5px
                margin-left: 7px
        .english_EnglishSystem2
          background: url(http://file.xdf.cn/neworiental/images/yxEmptybg.png?asd) no-repeat -555px -1255px
          h4
            font-size: 26px
            position: absolute
            top: 54px
            left: 96px
            color: #fff
          .english_systemlist
            position: absolute
            top: 130px
            left: 12px
            width: 230px
            height: 360px
            text-align: left
            li
              width: 100%
              margin-top: 10px
              h5
                font-size: 14px
                position: relative
                padding-left: 7px
              .color4-5
                color: #d1a501
              p
                line-height: 22px
                color: #666666
                margin-top: 5px
                margin-left: 7px
        .english_EnglishSystem3
          background: url(http://file.xdf.cn/neworiental/images/yxEmptybg.png?asd) no-repeat -852px -1255px
          h4
            font-size: 26px
            position: absolute
            top: 55px
            left: 100px
            color: #fff
          .english_systemlist
            position: absolute
            top: 130px
            left: 12px
            width: 230px
            height: 360px
            text-align: left
            li
              width: 100%
              margin-top: 10px
              h5
                font-size: 14px
                position: relative
                padding-left: 7px
                .color5-6
                  color: #02a8c3
              p
                line-height: 22px
                color: #666666
                margin-top: 5px
                margin-left: 7px
      .english_Englishxinzhi
        width: 840px
        height: 124px
        margin: 20px auto
        background: #f5f7fa
        border-radius: 5px
        margin-left: 28px
        .english_Englishxinzhileft
          font-size: 24px
          color: #ea4e58
          width: 100px
          height: 76px
          border-right: 1px solid #d2d3d4
          padding-top: 7px
          margin-top: 20px
        .english_Englishxinzhileft span
          display:block
          margin-top: 7px;
        .english_Englishxinzhiright
          width: 735px
          height: 76px
          margin-top: 27px
          text-align: left
          p
            font-size: 18px
            margin: 0px 0 7px 20px
          ul
            li
              float: left
              margin: 5px 21px
              font-size: 14px
      .english_emptytit
        font-size: 26px
        color: #31a893
        margin-top: 75px
      .english_featurelist
        width: 934px
        margin: 40px auto
        margin-top: 50px
        li
          width: 223px
          height: 210px
          float: left
          p
            font-size: 13px
            color: #666666
            line-height: 20px
            margin-top: 122px
        .english_featurelist1
          background: url(http://file.xdf.cn/neworiental/images/yxEmptybg.png?asd) no-repeat -210px -2071px
        .english_featurelist2
          background: url(http://file.xdf.cn/neworiental/images/yxEmptybg.png?asd) no-repeat -450px -2071px
        .english_featurelist3
          background: url(http://file.xdf.cn/neworiental/images/yxEmptybg.png?asd) no-repeat -685px -2071px
        .english_featurelist4
          background: url(http://file.xdf.cn/neworiental/images/yxEmptybg.png?asd) no-repeat -918px -2071px
      .english_Mathtip
        width: 900px
        margin: 0px auto
        margin-top: 46px
        line-height: 28px
        font-size: 16px
        color: #666666
      .english_Mathtopbox
        width: 850px
        height: 272px
        background: #f5f5f5
        border-radius: 10px
        margin: 0 auto
        margin-top: 20px
        font-size: 16px
        color: #666666
        position: relative
        div
          width: 536px
          height: 240px
          margin: 0px auto
          background: url(http://file.xdf.cn/neworiental/images/yxEmptybg.png?asd) no-repeat -307px -2400px
          position: relative
          p
            position: absolute
            left: 9px
          .english_Mathtip1
            top: 97px
          .english_Mathtip2
            top: 160px
          .english_Mathtip3
            top: 212px
      .english_Mathmidbox
        width: 850px
        height: 238px
        border-radius: 10px
        margin: 0 auto
        margin-top: 20px
        font-size: 16px
        color: #666666
        position: relative
        i
          position: absolute
          top: 40px
          left: 0
          width: 850px
          height: 60px
          background: url(http://file.xdf.cn/neworiental/images/yxEmptybg.png?asd) no-repeat -240px -1902px
        ul
          width: 100%
          position: absolute
          top: 128px
          left: 10px
          li
            h3
              font-size: 18px
              margin-bottom: 15px
            p
              font-size: 14px
              color: #666666
              margin-top: 7px
          .english_Mathmid1
            width: 23%
            margin-left: -12px
          .english_Mathmid2
            width: 51%
          .english_Mathmid3
            width: 21%
            margin-left: 33px
      .english_Mathbotbox
        height: 520px
        width: 900px
        border-radius: 10px
        margin: 73px auto 0
        font-size: 16px
        color: #666666
        position: relative
        i
          position: absolute
          top: 40px
          left: 284px
          width: 332px
          height: 332px
          background: url(http://file.xdf.cn/neworiental/images/yxEmptybg.png?asd) no-repeat -1039px -2402px
        h4
          font-size: 16px
          color: #43add3
          position: absolute
          top: 145px
          left: 365px
          line-height: 26px
          span
            font-size: 22px
            margin-bottom: 10px
            display: inline-block
        p
          font-size: 14px
          color: #666666
          padding: 10px 12px
          line-height: 26px
          border-radius: 5px
          position: absolute
        .english_Mathbot1
          width: 206px
          text-align: right
          background: #fef9e5
          top: -14px
          left: 112px
        .english_Mathbot2
          width: 210px
          text-align: right
          background: #fbebf1
          top: 130px
          left: 15px
        .english_Mathbot3
          width: 215px
          text-align: right
          background: #e6eef4
          top: 294px
          left: 40px
        .english_Mathbot4
          width: 250px
          background: #e8f6fa
          top: 388px
          left: 320px
          text-align: left
        .english_Mathbot5
          width: 238px
          text-align: left
          background: #e8f8f4
          top: 274px
          left: 611px
        .english_Mathbot6
          width: 210px
          text-align: left
          background: #fde9eb
          top: 108px
          left: 635px
        .english_Mathbot7
          width: 209px
          background: #fff1d9
          top: -40px
          left: 555px
      .english_YuwenSystem
        width: 948px
        margin: 0 auto
        margin-left: 13px
        margin-top: 20px
        div
          width: 285px
          height: 520px
          margin: 0px 2px
          position: relative
          h4
            color: #FFFFFF
            font-size: 16px
            position: absolute
            top: 20px
            left: 10px
            p
              span
                font-size: 20px
                display: block
              em
                font-size: 14px
                display: block
                margin-left: 1px
            .english_Yuwenleftword
              margin-left: 11px
              margin-top: 0px
            .english_Yuwenrightword
              margin-left: 30px
              text-align: left
              line-height: 22px
          .english_systemlistyw
            width: 247px
            position: absolute
            top: 75px
            left: 31px
            li
              width: 100%
              margin-top: 31px
              h5
                font-size: 16px
                width: 20%
                float: left
              .color3-4
                color: #f5626b
              .color5-6
                color: #02a8c3
              .color7-8
                color: #8bad02
              p
                font-size: 15px
                width: 150px
                float: left
                line-height: 28px
                margin-left: 25px
                text-align: left
                margin-top: -3px
          .width160
            left: 29px
            li
              p
                width: 160px
        .english_YuwenSystem1
          background: url(http://file.xdf.cn/neworiental/images/yxEmptybg.png?asd) no-repeat -233px -20px
        .english_YuwenSystem2
          background: url(http://file.xdf.cn/neworiental/images/yxEmptybg.png?asd) no-repeat -548px -20px
        .english_YuwenSystem3
          background: url(http://file.xdf.cn/neworiental/images/yxEmptybg.png?asd) no-repeat -866px -20px
      .english_Yuwenmidbox
        width: 900px
        height: 450px
        border-radius: 10px
        margin: 0 auto
        font-size: 16px
        color: #666666
        position: relative
        margin-left: 10px
        i
          width: 348px
          height: 265px
          position: absolute
          top: 85px
          left: 277px
          background: url(http://file.xdf.cn/neworiental/images/yxEmptybg.png?asd) no-repeat -529px -776px
        ul
          width: 272px
          li
            width: 272px
            position: absolute
            top: 54px
            left: 10px
            h3
              font-size: 18px
              float: left
              margin-right: 10px
              line-height: 22px
            p
              float: left
              width: 196px
              height: 90px
              border-left: 1px solid #c6c6c6
              color: #666666
              font-size: 14px
              padding-left: 8px
              text-align: left
              line-height: 22px
          .english_Yuwenmidli1
            h3
              color: #03acc8
          .english_Yuwenmidli2
            top: 183px
            h3
              color: #ea777e
          .english_Yuwenmidli3
            top: 310px
            h3
              color: #2bb4b5
            p
              height: 110px
          .english_Yuwenmidli4
            top: 54px
            left: 637px
            h3
              color: #fb7b43
            p
              width: 150px
          .english_Yuwenmidli5
            top: 173px
            left: 637px
            h3
              color: #50a6de
            p
              width:185px
              height: 110px
          .english_Yuwenmidli6
            top: 310px
            left: 637px
            h3
              color: #ec75ad
            p
             width:150px
</style>



// WEBPACK FOOTER //
// src/pages/english/components/mainfloor/Mainfloor.vue